import { render, staticRenderFns } from "./nearly-expired-and-re-order-product.vue?vue&type=template&id=3900b59e&scoped=true&"
import script from "./nearly-expired-and-re-order-product.vue?vue&type=script&lang=js&"
export * from "./nearly-expired-and-re-order-product.vue?vue&type=script&lang=js&"
import style0 from "./nearly-expired-and-re-order-product.vue?vue&type=style&index=0&id=3900b59e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3900b59e",
  null
  
)

export default component.exports